import { Box, Flex, Text, Button, Image, HStack, Drawer, IconButton, VStack, Portal} from "@chakra-ui/react";
import { AiFillProduct} from "react-icons/ai";
import logo from "../images/logo.png";

const Links = [
    {"name":"Tentang Kami","link":"/about"},
    {"name":"Layanan Kami","link":"/service"}
];

const NavLink = ({ src,children }) => (
  <Button
    px={3}
    py={2}
    variant="ghost"
    fontWeight="medium"
    textStyle={{ base:'md', lg:'lg' }}
    _hover={{ bg: "gray.200" }}
    asChild
  >
    <a href={src}>{children}</a>
  </Button>
);

const Header = () => {
    return (
        <Box bg="gray.100" boxShadow="sm" position="sticky" top="0" zIndex="1000" maxW='100%' overflowX="hidden">
            <Flex direction="row" align='center' bg='grey/5' w='100%' maxW="100%" overflow="hidden" px={4}>
                <Button h="100px" maxW={{base:'270px',md:'inherit'}} marginEnd="auto" variant="plain" asChild>
                    <a href="/">
                        <Flex direction="row" align='center' gap={2}>
                            <Image height={{base:"60px",md:"100px"}} src={logo} />
                            <Flex direction="column" maxW={{base:'140px',md:'inherit'}}>
                                <Flex direction="row" align='center' flexWrap="wrap" >
                                    <Text textStyle="lg" fontWeight="bold" color='green.600' mr='1'>Ikhlas</Text>
                                    <Text textStyle="lg" fontWeight="bold" color='blue.500' mr='1'>Bangun</Text>
                                    <Text textStyle="lg" fontWeight="bold" color='gray.600'>Griya</Text>
                                </Flex>
                                <Text textStyle="sm" fontWeight="bold" display={{base: "none", md: "flex"}} color='gray.500'>Bangun Griya Wujudkan Asa</Text>
                            </Flex>
                        </Flex>
                    </a>
                </Button>
                <HStack spacing={6} display={{ base: "none", md: "flex" }} flexWrap="wrap">
                    {Links.map((link) => (
                        <NavLink key={link.name} src={link.link}>{link.name}</NavLink>
                    ))}
                    <Button 
                        flexShrink={0}
                        color='white' 
                        textStyle="md" 
                        fontWeight="bold" 
                        bgGradient="to-r" 
                        gradientFrom="green.600" 
                        gradientTo="blue.500"
                        rounded="full"
                        asChild>
                            <a href='/showroom'>Showroom</a>
                    </Button>
                </HStack>

                {/* Mobile Hamburger */}
                <Drawer.Root placement="start">
                    <Drawer.Trigger asChild>
                        <IconButton
                            size="md"
                            bgGradient="to-r"
                            gradientFrom="blue.500"
                            gradientTo="green.600"
                            colorPalette="green"
                            aria-label="Open Menu"
                            display={{ md: "none" }}
                        >
                            <AiFillProduct />
                        </IconButton>
                    </Drawer.Trigger>
                    <Portal>
                        <Drawer.Backdrop />
                        <Drawer.Positioner>
                            <Drawer.Content bg="blue.50" maxW={"60%"}>
                                <Drawer.Header bgGradient="to-r" gradientFrom="blue.500" gradientTo="green.600">
                                    <Drawer.Title color="white">Menu</Drawer.Title>
                                </Drawer.Header>
                                <Drawer.Body>
                                    <VStack align="stretch" spacing={4}>
                                        {Links.map((link) => (
                                            <Button
                                                key={link.name}
                                                as="a"
                                                href={link.link}
                                                rel="noreferrer"
                                                colorScheme="blue"
                                                variant="ghost"
                                            >
                                                {link.name}
                                            </Button>
                                        ))}

                                        <Button
                                            as="a"
                                            href="/showroom"
                                            rel="noreferrer"
                                            color="white"
                                            bg="blue.500"
                                            fontWeight="bold"
                                            _hover={{ bg: "blue.600" }}
                                        >
                                            Showroom
                                        </Button>
                                    </VStack>
                                </Drawer.Body>
                            </Drawer.Content>
                        </Drawer.Positioner>
                    </Portal>
                </Drawer.Root>
            </Flex>
        </Box>
    );
}

export default Header;